import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../sections/CheckinEntry";
import MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry from "../../../sections/DirectiveEntry/entries/ExecutionEntry";
import MaintenanceWorkflowForwardingFiscalAssessmentEntrySection from "../../../sections/FiscalAssessmentEntry";

const ExecutionEntryOnGoingFiscalAssessment = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingFiscalAssessmentEntrySection />

      <MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry
        showCompleted
      />

      <MaintenanceWorkflowForwardingCheckinEntrySection />
    </>
  );
}

export default ExecutionEntryOnGoingFiscalAssessment;
